import React, {useEffect, useState} from "react";
import {X} from "react-feather";
import {vendorGetSingleClientReview} from "../../../services/api/clientReviews";
import ProgressBar from "../../../components/ClientReviews/ProgressBar";
import Star from "../../../components/Icons/Star";
import {moment} from "../../../services/moment-extensions";

const ViewReviewModal = ({onClose, reviewId}) => {

    const [reviewData, setReviewData] = useState(null);

    const getReviewData = async () => {
        const data = await vendorGetSingleClientReview(reviewId);
        setReviewData(data);
    }

    useEffect(() => {
            if (reviewId)
                getReviewData().catch(() => {

                });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [reviewId])


    if (!reviewData)
        return <div/>;

    return (
        <div className="sl-modal-body">
            <div
                className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title"
                     className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    Review Details
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0">
                    <X onClick={onClose} size={20}/>
                </div>
            </div>
            <div className="sl-modal-body">
                <div id="overview"
                     className="content-section sl-rounded-xl sl-pt-24 sl-pl-24  sl-pr-24 ">

                    <div className="sl-flex sl-flex-row sl-justify-between sl-mb-8">

                        <div className="sl-flex sl-flex-row  ">


                            {!reviewData.linkedin_photo &&
                            <span
                                className="sl-h-10 sl-w-10 sl-avatar sl-bg-gray-100 sl-inline-flex sl-font sl-font-normal sl-text-lg sl-text-gray-600"
                                data-letters={reviewData.initials}>
                        </span>}

                            {reviewData.linkedin_photo &&
                            <img
                                className="sl-h-10 sl-w-10 sl-avatar sl-bg-gray-100 sl-inline-flex sl-font sl-font-normal sl-text-lg sl-text-gray-600"
                                src={reviewData.linkedin_photo} alt={'linkedin'}/>}


                            <div className="sl-flex sl-flex-col sl-pl-10 sl-overflow-hidden sl-justify-center	">
                                <div
                                    className="sl-font sl-font-medium sl-text-sm sl-text-gray-700">{reviewData.name}</div>


                                <span
                                    className="sl-m-0 sl-p-0 sl-flex sl-flex-row sl-font sl-font-normal sl-text-xs sl-text-gray-base  sl-mr-2 sl-list-p-0">
                                    <span className={"sl-max-w-110 sl-break-all"}>{reviewData.client_name}</span>
                                    {reviewData.client_name &&
                                    <span className={"bullet-span sl-ml-2 sl-mr-2 sl-text-gray-500 sl-h-4"}></span>}
                                    <span className={"sl-ellipsis"}>
                                        {moment(reviewData.review_date).toMediumDate()}
                                    </span>
                                </span>

                            </div>
                        </div>

                        <div className="sl-flex sl-flex-col  sl-justify-center "><span
                            className="sl-font sl-font-normal  sl-text-xs sl-text-gray-base sl-ellipsis ">

                                        <div className="sl-display-flex ">
                                        <div className="sl-display-flex ">
                                        <Star/>
                                        <span
                                            className="sl-pl-2 sl-m-auto sl-f sl-text-20 sl-font-semibold sl-text-gray-900">
                                    {reviewData.overall_score}</span>
                                        </div>
                                        <span className="sl-pl-12 sl-m-auto sl-f sl-text-sm sl-text-gray-700">Overall score</span>
                                        </div>

                                        </span>
                        </div>
                    </div>


                    <div className="overview-info sl-display-flex sl-flex-row sl-gap-8">
                        <div className="sl-display-flex sl-flex-col sl-width-100 sl-gap-3">
                            <ProgressBar rating={reviewData.q0} title={'Profile'}/>
                            <ProgressBar rating={reviewData.q1} title={'Vision'}/>
                            <ProgressBar rating={reviewData.q2} title={'Potential'}/>
                            <ProgressBar rating={reviewData.q9} title={'Support'}/>
                        </div>

                        <div className="sl-display-flex sl-flex-col sl-width-100 sl-gap-3">
                            <ProgressBar rating={reviewData.q3} title={'Product'}/>
                            <ProgressBar rating={reviewData.q4} title={'Technology'}/>
                            <ProgressBar rating={reviewData.q5} title={'Flexibility'}/>
                        </div>
                        <div className="sl-display-flex sl-flex-col sl-width-100 sl-gap-3">
                            <ProgressBar rating={reviewData.q6} title={'Implementation'}/>
                            <ProgressBar rating={reviewData.q7} title={'Data'}/>
                            <ProgressBar rating={reviewData.q8} title={'People'}/>
                        </div>
                    </div>


                    <div className="sl-flex sl-gap-8 sl-flex-col">
                        {reviewData.comment && <div className="overview-info">
                            <h3 className="sl-mb-3 sl-mt-8">Review</h3>
                            <div className="overview-company-info ">
                                <p className="see-more-content sl-mb-2 sl-break-all">
                                    "{reviewData.comment}"
                                </p>
                            </div>
                        </div>}

                        {reviewData.improvements && <div className="overview-info">
                            <h3 className="sl-mb-3 sl-mt-0">Suggested improvements</h3>
                            <div className="overview-company-info ">
                                <p className="see-more-content sl-mb-2 sl-break-all">
                                    {reviewData.improvements}
                                </p>
                            </div>
                        </div>}
                    </div>

                </div>

            </div>


            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button
                        onClick={onClose}
                        className="sl-btn sl-btn-tertiary sl-btn-lg sl-rounded-lg">
                        Close
                    </button>

                </div>
            </div>
        </div>
    );
}

export default ViewReviewModal;
